export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-25.7b165ea3.jpg";